import React, { useState, useEffect } from 'react';
import { FiPlus, FiSend } from 'react-icons/fi';
import AddSubmittalModal from '../components/AddSubmittalModal';
import SubmittalDetailModal from '../components/SubmittalDetailModal';
import './Submittals.css';

const Submittals = ({ token }) => {
  const [submittals, setSubmittals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedSubmittal, setSelectedSubmittal] = useState(null);

  useEffect(() => {
    fetchSubmittals();
  }, []);

  const fetchSubmittals = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/submittals`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setSubmittals(data.submittals || []);
      }
    } catch (error) {
      console.error('Failed to fetch submittals:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSubmittal = () => {
    fetchSubmittals();
  };

  const handleUpdateSubmittal = () => {
    fetchSubmittals();
    setSelectedSubmittal(null);
  };

  const getStatusColor = (status) => {
    const colors = {
      'Pending': '#F4A340',
      'In Review': '#0F0F10',
      'Approved': '#1DBF73',
      'Rejected': '#E24B5B'
    };
    return colors[status] || '#F4A340';
  };

  if (loading) return <div className="loading-spinner"></div>;

  return (
    <div className="submittals-page">
      <div className="submittals-header">
        <h1 className="submittals-title">Submittals</h1>
        <button 
          className="btn btn-primary" 
          onClick={() => setShowAddModal(true)}
          data-testid="create-submittal-button"
        >
          <FiPlus size={18} />
          <span>New Submittal</span>
        </button>
      </div>
      
      <AddSubmittalModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onAdd={handleAddSubmittal}
        token={token}
      />
      
      <SubmittalDetailModal
        isOpen={!!selectedSubmittal}
        onClose={() => setSelectedSubmittal(null)}
        submittal={selectedSubmittal}
        token={token}
        onUpdate={handleUpdateSubmittal}
      />
      
      <div className="submittals-grid">
        {submittals.map((submittal) => (
          <div 
            key={submittal.id} 
            className="submittal-card" 
            onClick={() => setSelectedSubmittal(submittal)}
            data-testid="submittal-card"
            style={{ borderLeft: `4px solid ${getStatusColor(submittal.status)}` }}
          >
            <div className="submittal-card-header">
              <div 
                className="submittal-card-icon"
                style={{ 
                  backgroundColor: `${getStatusColor(submittal.status)}20`,
                  color: getStatusColor(submittal.status)
                }}
              >
                <FiSend size={20} />
              </div>
              <span 
                className="status-pill"
                style={{ 
                  backgroundColor: getStatusColor(submittal.status),
                  color: '#ffffff'
                }}
              >
                {submittal.status}
              </span>
            </div>
            <div className="submittal-card-id">{submittal.submittalId}</div>
            <div className="submittal-card-title">{submittal.title}</div>
            <div className="submittal-card-desc">{submittal.description}</div>
            {submittal.returnDate && (
              <div className="submittal-card-due">Return: {new Date(submittal.returnDate).toLocaleDateString()}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Submittals;